import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import VisionHero from "../sections/VisionHero";
import VisionProcess from "../sections/VisionProcess";
import VisionFrames from "../sections/VisionFrames";
import VisionPrompts from "../sections/VisionPrompts";
import VisionTrust from "../sections/VisionTrust";
import VisionClosing from "../sections/VisionClosing";

const HomeVisionPage = () => (
    <div className="min-h-screen bg-ink text-white">
        <Seo
            title="Home Vision — See Your Home Before You Build It | BuildEase"
            description="Explore AI-generated visual concepts of your planned home — exterior, interior and finishes — before construction begins. Concepts, not construction drawings."
        />
        <Navbar />
        <main>
            <VisionHero />
            <VisionProcess />
            <VisionFrames />
            <VisionPrompts />
            <VisionTrust />
            <VisionClosing />
        </main>
        <Footer />
    </div>
);

export default HomeVisionPage;
